<template lang="pug">
  el-autocomplete(
    :name="name"
    v-model="model[name]"
    :fetch-suggestions="querySearchAsync"
    @select="handleSelect"
  )
</template>

<script>
  import {dadata} from "../../api/api-endpoints";
  import {DADATA_TOKEN} from "../../config/config";

  export default {
    name: "data-autocomplete",
    props: {
      name: {
        type: String,
        default: null,
        required: true
      },
      model: {
        type: Object,
        required: true
      },
    },
    data(){
      return {
        result:[]
      }
    },
    methods:{
      querySearchAsync(queryString, cd) {
        this.getDaData(queryString, cd)
      },
      createFilter(queryString) {
        return (link) => {
          console.log(queryString)
          return (link);
        };
      },
      getDaData(query, cd){
        let options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": "Token " + DADATA_TOKEN
          },
          body: JSON.stringify({query: query})
        }
        fetch(dadata.suggestInnOgrn(), options)
          .then(response => response.text())
          .then((result)=> {
            this.result = JSON.parse(result).suggestions
            cd(this.result)
          })
          .catch(error => console.log("error", error));
      },
      handleSelect(item) {
        this.model['inn'] = item.data.inn
        this.model['ogrn'] = item.data.ogrn
        this.model['kpp'] = item.data.kpp
        this.model['okpo'] = item.data.okpo
        this.model['name'] = item.data.name.full_with_opf
        this.model['short_name'] = item.data.name.short_with_opf
        this.model['okpo'] = item.data.okpo
        this.model['head_name'] = item.data?.management.name
        this.model['head_position']= item.data?.management.post
        this.model['fact_address']=item.data.address.value
        this.model['legal_address']=item.data.address.value
        this.model['okved']['code']=item.data.okved
        this.model['geo_lat'] = item.data.address.data.geo_lat
        this.model['geo_lon'] = item.data.address.data.geo_lon
        this.model['latitude'] = item.data.address.data.geo_lat
        this.model['longitude'] = item.data.address.data.geo_lon
      }
    }
  }
</script>

<style scoped>

</style>